import axios from 'axios';
axios.defaults.withCredentials = true;
import { logError } from '../../taskpane/utils/request';
import { fetchToken } from '../fetchToken';
const API_URL = process.env.EMAILS_API_URL;

/**
   * Logs the user out of the plugin.
   * @return {object} API response from the Emails API.
*/
export const logoutUser = async () => {
  const token = await fetchToken();
  const config = {
    method: 'DELETE',
    url: API_URL + 'auth/logout',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    return e;
  }
};

/**
   * Checks if user is authenticated.
   * @return {object} API response from the Emails API.
*/
export const getAuthStatus = async () => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: API_URL + 'auth/exchange/status',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};

/**
   * Gets user data from the Emails API.
   * @return {object} API response from the Emails API.
*/
export const getUser = async () => {
  const token = await fetchToken();
  const config = {
    method: 'GET',
    url: API_URL + 'users',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    return await axios(config);
  } catch (e) {
    logError(e);
    throw e;
  }
};
